import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b9c0f300"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "com-contentTwo-box"
};
const _hoisted_2 = {
  class: "com-contentTwo-items"
};
const _hoisted_3 = {
  class: "com-contentTwo-buttons-div"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shangyige"
}, null, -1));
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shangyige-copy"
}, null, -1));
const _hoisted_7 = [_hoisted_6];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "com-contentTwo-con",
    style: _normalizeStyle('left:' + $data.left)
  }, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_image, {
    class: "com-contentTwo-vanImage",
    width: "auto",
    height: "100%",
    fit: "cover",
    src: $data.currentSrc
  }, null, 8, ["src"])])], 4), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: "com-contentTwo-button-div com-contentTwo-button-prev-div",
    onClick: _cache[0] || (_cache[0] = $event => $options.setSroll(-800))
  }, _hoisted_5), _createElementVNode("div", {
    class: "com-contentTwo-button-div com-contentTwo-button-next-div",
    onClick: _cache[1] || (_cache[1] = $event => $options.setSroll(800))
  }, _hoisted_7)])]);
}